exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cross-container{display:inline-block;width:30px;height:30px;cursor:pointer;margin-right:15px}.cross-container:hover .cross-bar{opacity:1}.cross-bar{height:1.9px;width:22.5px;margin:5.4px auto;background-color:#999;border-radius:3px;transition:all .5s ease;opacity:0}.cross-bar:first-child{opacity:1;margin-top:.4pc;transform:rotateZ(45deg) translate3d(5px,5px,0px)}.cross-container:hover .cross-bar:first-child{transform:translate3d(-7px,4px,0) rotate(-45deg) scaleX(0.4);border-radius:3px 0 0 3px}.cross-bar:last-child{opacity:1;margin-bottom:.4pc;transform:rotateZ(-45deg) translate3d(5px,-5px,0px)}.cross-container:hover .cross-bar:last-child{transform:translate3d(-7px,-4px,0) rotate(45deg) scaleX(0.4);border-radius:3px 0 0 3px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader/lib!./src/components/SideBar/components/Cross/style.css
 ** module id = 1668
 ** module chunks = 0
 **/